import ready from "./ready";

ready(() => {
    // noinspection JSIgnoredPromiseFromCall
    modifyACFormData();
})

async function modifyACFormData() {
    const form = document.querySelector('form._form');
    if (!form) {
        console.error('Form not found');
        return;
    }

    const selects = form.querySelectorAll('select');

    const res = await fetch('/wp-json/wp/v2/aanbod?per_page=100&orderby=title&order=asc');
    const body = await res.json();

    selects.forEach((select) => {
        const { name } = (select as HTMLSelectElement).dataset;
        const firstOption = select.querySelector('option') as HTMLOptionElement;

        if (!firstOption) {
            console.error('First option not found');
            return;
        }

        firstOption.innerHTML = 'Maak een keuze';

        if (['voorkeur_1_beelsbeecke', 'voorkeur_2_beelsbeecke', 'voorkeur_3_beelsbeecke'].includes(name || '')) {

            const options = select.querySelectorAll('option');

            // Remove options as AC is already filled
            for (let i = 1; i < options.length; i++) {
                options[i].remove();
            }

            firstOption.innerHTML = 'Selecteer een voorkeur';
            firstOption.setAttribute('placeholder', 'placeholder');
            firstOption.setAttribute('value', '');

            const inputTarget = name?.replace('_beelsbeecke', '_keuze');
            if (!inputTarget) {
                console.error('Input target not found');
                return;
            }

            console.log(inputTarget);

            const target = form.querySelector('[data-name="' + inputTarget + '"]') as HTMLInputElement;

            if (!target) {
                console.error('Target not found');
                return;
            }

            select.addEventListener('change', (e) => {
                target.value = (e.target as HTMLSelectElement).value;
            });

            body.forEach(({ title, meta_data }) => {
                console.log(title);
                console.log(meta_data);

                const option = document.createElement('option');
                option.value = title.rendered;
                option.innerHTML = title.rendered;

                if (meta_data.status === 'sold') {
                    option.innerHTML = title.rendered + '(verkocht)';
                    option.setAttribute('disabled', 'true');
                }

                if (meta_data.status === 'rented') {
                    option.innerHTML = title.rendered + '(verhuurd)';
                    option.setAttribute('disabled', 'true');
                }

                if (name === 'voorkeur_1_beelsbeecke' && window.location.search.includes('voorkeur')) {
                    const params = new URLSearchParams(window.location.search);
                    option.selected = params.get('voorkeur') === title.rendered;
                }
                (select as HTMLSelectElement).appendChild(option);
                (select as HTMLSelectElement).dispatchEvent(new Event('change'));
            });
        }
    });
}